import { Globe } from "lucide-react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { PublicPlaylist } from "@classview/shared-types";

import { useAddRecordingToPlaylist } from "../api/add-recording-to-playlist";

type PlaylistItemProps = {
  playlist: PublicPlaylist;
  recordingId: string;
};

export function PlaylistItem(props: PlaylistItemProps) {
  const { organisation } = useOrganisation();
  const { mutateAsync: addToPlaylist, isPending } = useAddRecordingToPlaylist({
    onSuccess: () => {
      toast.success("Recording added to playlist");
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  const handleAddToPlaylist = async () => {
    await addToPlaylist({
      playlistId: props.playlist.id,
      recordingId: props.recordingId,
      orgId: organisation.id,
    });
  };

  return (
    <Button
      type="button"
      variant="ghost"
      className="w-full justify-start"
      onClick={handleAddToPlaylist}
      disabled={isPending}
    >
      <Checkbox aria-hidden={true} className="mr-2" />
      <p>{props.playlist.name}</p>
      {props.playlist.isPublic && (
        <div className="ml-4 flex items-center gap-1">
          <Globe className="mr-0.5 size-4 text-blue-500" />
          <span className="text-xs">Public</span>
        </div>
      )}
    </Button>
  );
}
